<template>
  <div>
    <div class="position-relative mb-3">
      <section class="section-profile-cover section-shaped my-0">
        <div class="shape shape-style-1 shape-yellowdark shape-skew alpha-4">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </section>
      <section class="section-skew">
        <div class="container-section">
          <card shadow class="section-home">
            <div class="row row-grid">
              <div
                class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
              >
                <div class="title-product">
                  <h3>طراحی و توسعه انواع وبسایت و وب اپلیکیشن</h3>
                  <p>
                    طراحی وب سایت به مهارت و فرایند ساخت و راه اندازی صفحات وب
                    گفته می شود. وب سایت کسب و کار و برند شما، ویترینی برای
                    معرفی خدمات و محصولات ارائه شده توسط شماست. از این رو هرچه
                    این ویترین جذاب‌تر و بی‌نقص‌تر باشد، احتمال دیده شدن کسب و
                    کار و برند شما بیشتر است.
                  </p>
                  <p>
                    با طراحی یک وب اپلیکیشن انحصاری برای کسب و کار شما، همیشه و
                    در همه‌جا در دسترس مشتریان خود باشید. این ابزار قدرتمند نه
                    تنها تعامل و رضایت مشتریان شما را افزایش می‌دهد، بلکه به شما
                    امکان می‌دهد تا به راحتی خدمات و محصولات خود را به‌روز کنید
                    و با یکپارچگی آسان با دیگر سیستم‌ها، کارایی عملیاتی خود را
                    افزایش دهید.
                  </p>
                  <base-button
                    type="navyDark"
                    round
                    block
                    size="md"
                    @click="scrollToProject"
                  >
                    مشاهده پروژه‌ها
                  </base-button>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div class="img-project">
                  <img src="img/project/Website.svg" alt="" />
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>

    <section class="section" ref="projectSection">
      <div class="container-section">
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          class="section-Popular-tours"
        >
          <h3>پروژه‌ها</h3>
        </b-col>
        <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <hooper
            :settings="hooperSettings"
            :autoPlay="true"
            :playSpeed="2000"
            style="height:300px"
          >
            <slide
              v-for="(item, index) in listSlider"
              :key="index"
              class="slider-project"
            >
              <card class="shadow-lg--hover card-slider">
                <a :href="item.link">
                  <div class="image-slider">
                    <img :src="item.src" alt="" />
                  </div>
                  <div class="items-slider">
                    <h6>{{ item.name }}</h6>
                  </div>
                </a>
              </card>
            </slide>
          </hooper>
        </b-col>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container-section">
        <div class="row row-grid">
          <div class="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12 text-right">
            <div class="row row-grid">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div
                  class="section-users"
                  :class="[
                    'box-card-service',
                    cardVisible[1] ? 'visible' : 'hidden',
                  ]"
                >
                  <h3>لیست پروژه‌های طراحی و توسعه وبسایت‌</h3>
                  <p>
                    ممکن است برخی نمونه کارها پس از تحویل به مشتریان ما، از
                    دسترس خارج شده باشند
                  </p>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div
                  :class="[
                    'box-card-service',
                    cardVisible[2] ? 'visible' : 'hidden',
                  ]"
                >
                  <ul class="list-unstyled">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          موسسه تله مدیسن یسنا
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          اولین همایش ملی HSE در صنعت فولاد
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          کانون رشد مدرسه فردا
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          سنجش، مشاوره و تحلیل آدینه – سمتاد
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          اولین المپیاد ملی جغرافیا – iranigo
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          آریا دلتا مد – مهندسی پزشکی
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          موسسه خیریه رعد طالقان
                        </h6>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div
                  :class="[
                    'box-card-service',
                    cardVisible[3] ? 'visible' : 'hidden',
                  ]"
                >
                  <ul class="list-unstyled">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          دکتر خلج
                        </h6>
                      </div>
                    </li>

                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          ای‌مولاژ- آموزش خیاطی
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          سازمان حفاظت از محیط زیست
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          سگال – مدرسه هزاره سوم
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          معرفی قراردادهای هوشمند
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          سبزپرداخت – سامانه پرداخت قبوض
                        </h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="navyDark"
                          circle
                          class="ml-3"
                          icon="fa fa-certificate"
                        ></badge>
                        <h6 class="mb-0">
                          9 اقلیم – بوم گردی
                        </h6>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[0] ? 'visible' : 'hidden',
              ]"
            >
              <div class="card bg-yellowdark shadow border-0">
                <img
                  v-lazy="'img/project/Creator-cuate.svg'"
                  class="card-img-top img-section-card-dark"
                />
                <blockquote class="card-blockquote">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    class="svg-bg"
                  >
                    <polygon
                      points="0,52 583,95 0,95"
                      class="fill-yellowdark"
                    ></polygon>
                    <polygon
                      points="0,42 583,95 683,0 0,95"
                      opacity=".2"
                      class="fill-yellowdark"
                    ></polygon>
                  </svg>
                  <div class="title-section-help">
                    <h1>
                      وبسایت شما، هویت دیجیتال ما!
                    </h1>
                    <p>
                      با طراحی خلاقانه و توسعه‌ی تخصصی وبسایت شما، موفقیت
                      کسب‌وکارتان در دنیای دیجیتال را تضمین می‌کنیم
                    </p>
                  </div>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-skew">
      <div class="container-section">
        <div class="row row-grid align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[4] ? 'visible' : 'hidden',
              ]"
            >
              <div class="img-project">
                <img src="img/project/Interaction.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right">
            <div
              :class="[
                'box-card-service',
                cardVisible[5] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>طراحی و توسعه اپلیکیشن</h3>
                <p>
                  اپلیکیشن موبایل برای استفاده های خاصی طراحی می شود و هر
                  سازمانی می‌تواند بنا به نیاز خود یک اپلیکیشن مخصوص به خود را
                  تولید و طراحی نماید. اپلیکیشن تعداد بازدیدهای هر کاربر از
                  محصولات شما را افزایش می‌دهد و می‌تواند آنها را تبدیل به
                  مشتریان وفادار شما کند.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-secondary">
      <div class="container-section">
        <div class="row row-grid">
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-right">
            <div
              :class="[
                'box-card-service',
                cardVisible[6] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>لیست پروژه‌های طراحی و توسعه فروشگاه آنلاین</h3>
                <p>
                  ممکن است برخی نمونه کارها پس از تحویل به مشتریان ما، از دسترس
                  خارج شده باشند
                </p>
              </div>
              <ul class="list-unstyled mt-4">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      کتاب باز
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      پت کلاب آس
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      تیپیک سان
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      تکنیک پیچ
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[7] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>لیست پروژه‌های طراحی و توسعه وب‌اپلیکیشن</h3>
                <p>
                  ممکن است برخی نمونه کارها پس از تحویل به مشتریان ما، از دسترس
                  خارج شده باشند
                </p>
              </div>
              <ul class="list-unstyled mt-4">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      مارُک – اپلیکیشن جامع گردشگری
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      مانامداپ – اپلیکیشن نظرسنجی کیفیت خدمات بیمارستانی
                    </h6>
                  </div>
                </li>

                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      بهنواآنلاین
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      سیستم دعوتنامه الکترونیک رویدادهای VIP – مهسا زرگر
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[8] ? 'visible' : 'hidden',
              ]"
            >
              <div class="card bg-default shadow border-0">
                <img
                  v-lazy="'img/project/Software.svg'"
                  class="card-img-top img-section-card"
                />
                <blockquote class="card-blockquote">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    class="svg-bg"
                  >
                    <polygon
                      points="0,52 583,95 0,95"
                      class="fill-default"
                    ></polygon>
                    <polygon
                      points="0,42 583,95 683,0 0,95"
                      opacity=".2"
                      class="fill-default"
                    ></polygon>
                  </svg>
                  <div class="title-section-img">
                    <h1>
                      وب اپلیکیشن، راهکاری مدرن و هوشمند برای نیازهای کسب‌وکار
                      شما
                    </h1>
                    <p>
                      با بهره‌گیری از آخرین تکنولوژی‌ها و بهترین روش‌های طراحی،
                      به شما کمک می‌کنیم تا تجربه‌ای پیشرفته، کارآمد و بهینه را
                      برای کاربران خود فراهم کنید.
                    </p>
                  </div>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-skew">
      <div class="container-section">
        <div class="row row-grid align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[9] ? 'visible' : 'hidden',
              ]"
            >
              <div class="img-project">
                <img src="img/project/Design.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right">
            <div
              :class="[
                'box-card-service',
                cardVisible[10] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>سیستم‌های اتوماسیون</h3>
                <p>
                  شما به عنوان یک مدیر، علاقه‌مندید که بتوانید سرعت انجام کارهای
                  جاری و روزمره‌ را در سازمانتان بالا ببرید. اما واقعیت این است
                  که معمولا زمان زیادی صرف انجام مکاتبات و رسیدگی به درخواست‌ها
                  و نامه‌ها می‌شود. طبق مطالعات انجام شده، سازمان‌ها و شرکت‌های
                  سنتی عملا تنها از ۳۰% زمانی که صرف فرایند‌هایشان کرده‌اند،
                  ارزش افزوده دریافت می‌کنند و از ۷۰% باقیمانده غیر از اتلاف وقت
                  و هزینه چیزی عایدشان نمی‌شود. سیستم اتوماسیون اداری، با
                  خودکارسازی بخش‌های متنوعی از فرایندهای اداری، راه حلی جهت رفع
                  مشکلات مطرح شده در بالا محسوب می‌شوند.
                </p>
                <p>
                  به بیان دیگر سیستم اتوماسیون اداری یک سیستم اطلاعاتی مبتنی بر
                  کامپیو‌تر است که وظیفه جمع‌آوری، ذخیره و توزیع مستندات،
                  پیام‌های الکترونیک و سایر فرم‌های ارتباطات اداری را بین افراد،
                  گروه‌های کاری و سازمان‌ها بر عهده دارد. بخش‌هایی از این
                  سیستم‌ها عموما شامل نرم‌افزارهای پردازش کلمه، تصویر برداری
                  مستندات، تقویم و غیره است.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-secondary">
      <div class="container-section">
        <div class="row row-grid">
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[12] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>لیست پروژه‌های طراحی و توسعه سیستم‌های اتوماسیون</h3>
                <p>
                  ممکن است برخی نمونه کارها پس از تحویل به مشتریان ما، از دسترس
                  خارج شده باشند
                </p>
              </div>
              <ul class="list-unstyled mt-4">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      سامانه طرح تقسیم کار ملی ستاد زیست فناوری ریاست جمهوری
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      کلینیک پارسیان هشتگرد
                    </h6>
                  </div>
                </li>

                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      کلینیک زیبایی لیا
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      سامانه مدیریت سلامت
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      سامانه مدیریت جامع پولاد پیچ کار
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      سامانه مدیریت جامع ماجراهای شیرین
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      سامانه مدیریت نیروی انسانی کارخانجات فولاد ارومیه
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-right">
            <div
              :class="[
                'box-card-service',
                cardVisible[11] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>لیست پروژه‌های طراحی و توسعه سیستم‌های آموزشی</h3>
                <p>
                  ممکن است برخی نمونه کارها پس از تحویل به مشتریان ما، از دسترس
                  خارج شده باشند
                </p>
              </div>
              <ul class="list-unstyled mt-4">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      دانشگاه علمی کاربردی واحد پولادپیچ‌کار – کارانو
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      سازمان مردم نهاد نت حامی
                    </h6>
                  </div>
                </li>

                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="navyDark"
                      circle
                      class="ml-3"
                      icon="fa fa-certificate"
                    ></badge>
                    <h6 class="mb-0">
                      موسسه فرهنگی آموزشی ذهن برتر – دکتر محمد سیدا – پدر حافظه
                      ایران
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[13] ? 'visible' : 'hidden',
              ]"
            >
              <div class="card bg-yellowdark shadow border-0">
                <img
                  v-lazy="'img/project/Static.svg'"
                  class="card-img-top img-section-card-dark"
                />
                <blockquote class="card-blockquote">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    class="svg-bg"
                  >
                    <polygon
                      points="0,52 583,95 0,95"
                      class="fill-yellowdark"
                    ></polygon>
                    <polygon
                      points="0,42 583,95 683,0 0,95"
                      opacity=".2"
                      class="fill-yellowdark"
                    ></polygon>
                  </svg>
                  <div class="title-section-help">
                    <h1>
                      تجربه‌ای بی‌نظیر از نوآوری و عملکرد پیشرفته در سیستم‌های
                      اتوماسیون جامع!
                    </h1>
                    <p>
                      سیستم‌های اتوماسیون جامع، راهکاری تخصصی و همه‌جانبه برای
                      مدیریت یکپارچه سازمان شما ارائه می‌کنند تا بهره‌وری را به
                      حداکثر برسانید و زمان و هزینه‌ها را بهینه کنید.
                    </p>
                  </div>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-skew">
      <div class="container-section">
        <div class="row row-grid align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[14] ? 'visible' : 'hidden',
              ]"
            >
              <div class="img-project">
                <img src="img/project/Social.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right">
            <div
              :class="[
                'box-card-service',
                cardVisible[15] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>طراحی گرافیک و شبکه‌های اجتماعی</h3>
                <p>
                  طراحی گرافیک یعنی هنر برقراری ارتباط بصری از طریق عکس‌های
                  متنی، نمادها و کارهای هنری که وظیفه انجام آنها بر عهده‌ی یک
                  طراح گرفیک است. یک برند، رابطه مستقیم بین یک کسب و کار یا
                  سازمان با مخاطبان آن است. هویت یک برند، نحوه‌ی برقراری ارتباط
                  یک سازمان با شخصیت، لحن و ذات، همینطور خاطرات، احساسات و
                  تجربه‌هایش است. طراحی گرافیک هویت بصری، دقیقا به این شکل است:
                  عناصر بصری هویت برند که به عنوان وجهه‌ی یک برند در برقراری
                  ارتباط با خصوصیاتی نامشهود از طریق تصاویر، اشکال و رنگ‌ها، عمل
                  می‌کند.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-skew">
      <div class="container-section">
        <div class="row row-grid align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right">
            <div
              :class="[
                'box-card-service',
                cardVisible[16] ? 'visible' : 'hidden',
              ]"
            >
              <div class="section-users">
                <h3>سیستم‌های آموزشی</h3>
                <p>
                  با توجه به رشد چشمگیر کسب و کارهای آموزشی و رقابت روزافزون در
                  صنعت آموزش، بی تردید استفاده از فرآیندهای سرویس کلاس مجازی
                  دیگر یه گزینه نیست و میتواند تنها راه چاره باشد. با توجه به
                  اینکه گرایش به سمت خودکارسازی فرآیندها و کاهش خطای انسانی هر
                  روز در حال افزایش است، نرم افزارهای یکپارچه سرمد این چالش را
                  برای آموزشگاه‌ها و مدیران منابع انسانی سازمان‌ها حل نموده‌اند.
                  این سیستم‌ها قابلیت اتصال و یکپارچه سازی با سایر نرم افزارهای
                  سازمان شما را نیز دارا هستند.
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div
              :class="[
                'box-card-service',
                cardVisible[17] ? 'visible' : 'hidden',
              ]"
            >
              <div class="img-project">
                <img src="img/project/Learning.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import { slider, slideritem } from "vue-concise-slider";
import "hooper/dist/hooper.css";
import {
  Hooper,
  Slide,
  Progress as HooperProgress,
  Pagination as HooperPagination,
  Navigation as HooperNavigation,
} from "hooper";
export default {
  name: "projects",
  components: {
    slider,
    slideritem,
    Hooper,
    Slide,
    HooperProgress,
    HooperPagination,
    HooperNavigation,
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      cardVisible: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      hooperSettings: {
        infiniteScroll: true,
        centerMode: true,
        autoPlay: true,
        playSpeed: 3500,
        breakpoints: {
          2400: {
            itemsToShow: 5,
          },
          1800: {
            itemsToShow: 4,
          },
          1100: {
            itemsToShow: 3,
          },
          900: {
            itemsToShow: 3,
          },
          600: {
            itemsToShow: 2,
          },
          400: {
            itemsToShow: 1,
          },
        },
      },
      listSlider: [
        {
          src: "img/project/پولاد پیچکار.png",
          link: "https://ppkco.com/",
          name: "شرکت پولاد پیچ کار",
        },
        {
          src: "img/project/آس پت.png",
          link: "https://acepetclub.com/",
          name: "آس پت",
        },
        {
          src:
            "img/project/پرتال طرح تقسیم کار ملی ستاد زیست فناوری ریاست جمهوری1.png",
          link: "https://biodcportal.com/",
          name: "پرتال طرح تقسیم کار",
        },
        {
          src:
            "img/project/سامانه تقسیم سهام داینامیک با مشارکت کیارش عباس‌زاده.png",
          link: "https://app.slicingpie.ir/",
          name: "تقسیم سهام داینامیک",
        },
        {
          src: "img/project/سامانه نوبت دهی خانه کسب و کار.png",
          link: "https://hob.satr.app/",
          name: "خانه کسب و کار",
        },
        {
          src: "img/project/کتاب باز.png",
          link: "https://ketabbaaz.com/main",
          name: "کتاب باز",
        },
        {
          src: "img/project/مارُک.png",
          link: "https://marokapp.ir/",
          name: "مارک ",
        },
      ],
      showScrollButton: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
    scrollToProject() {
      const projectSection = this.$refs.projectSection;
      if (projectSection) {
        projectSection.scrollIntoView({ behavior: "smooth" });
      }
    },
    animateCards() {
      this.cardVisible.forEach((_, index) => {
        setTimeout(() => {
          this.$set(this.cardVisible, index, true);
        }, index * 1000);
      });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.animateCards();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
.hidden {
  opacity: 0;
  transform: translateX(100%);
  transition: opacity 1s ease, transform 1s ease;
}

.visible {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 1s ease, transform 1s ease;
}
</style>
